var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center-control",on:{"click":function($event){return _vm.$emit('onClick')}}},[(_vm.actionType === 'mapData')?_c('FontAwesomeIcon',{staticClass:"control-icon",attrs:{"icon":"map-marked-alt"}}):(_vm.actionType === 'currentLocation')?_c('FontAwesomeIcon',{staticClass:"control-icon",attrs:{"icon":"location-arrow"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }